// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const sk: KnowledgePagesCopy = {
  knowledgePage: 'Stránka znalostí',
  knowledgePages: 'Stránky znalostí',
  featureOffTitle: 'Stránky znalostí nie sú v tomto pracovnom priestore zapnuté.',
  featureOffBody: 'Kontext spoločnosti a zdroje sú naďalej v sekcii Znalosti.',
  loadingPage: 'Načítava sa stránka…',
  loadingSuggestion: 'Načítava sa návrh…',
  cancel: 'Zrušiť',
  tryAgain: 'Skúsiť znova',
  everyoneIn: 'Všetci v spoločnosti {company}',
  yourCompany: 'vašej spoločnosti',
  revision: 'Revízia {n}',
  openRevision: 'Otvoriť revíziu {n}',
  pageCount: 'one:stránka|few:stránky|many:stránky|other:stránok',
  topicCount: 'one:téma|few:témy|many:témy|other:tém',
  sectionCount: 'one:sekcia|few:sekcie|many:sekcie|other:sekcií',
  lineCount: 'one:riadok|few:riadky|many:riadka|other:riadkov',
  documentCount: 'one:dokument|few:dokumenty|many:dokumentu|other:dokumentov',
  changeCount: 'one:zmena|few:zmeny|many:zmeny|other:zmien',
  newPageCount: 'one:nová stránka|few:nové stránky|many:novej stránky|other:nových stránok',
  changedPageCount:
    'one:zmenená stránka|few:zmenené stránky|many:zmenenej stránky|other:zmenených stránok',
  otherSectionCount: 'one:ďalšia sekcia|few:ďalšie sekcie|many:ďalšej sekcie|other:ďalších sekcií',
  characterCount: 'one:znak|few:znaky|many:znaku|other:znakov',
  diffStats: 'Zmenené: {sections} · pridané: {added} · odstránené: {removed}',
  diffMatchesBase: 'Navrhovaný text sa zhoduje so základnou revíziou.',
  diffIntroduction: 'Úvod',
  diffOtherUnchanged: 'Bez zmeny: {sections}.',
  timeJustNow: 'práve teraz',
  originImportedFrom: 'Importované z {path}',
  originImportedFromCommit: 'Importované z {path} @ {commit}',
  authorityApprovedInPoneva: 'Schválené v Poneva',
  authorityImported: 'Importované',
  authorityInRepository: '{canonicality} v repozitári',
  authorityVerified: 'overené {date}',
  authorRepositoryImport: 'Import z repozitára',
  authorSuggestedInChat: 'Navrhnuté v chate',
  authorSuggestedInChatWith: 'Navrhnuté v chate s používateľom {name}',
  authorSuggestedBy: 'Navrhol(-a) {name}',
  authorSuggestedByApp: 'Navrhla pripojená aplikácia',
  authorSuggestedByColleague: 'Navrhol kolega',
  authorSuggestedByYou: 'Navrhli ste vy',
  authorSuggestedOnBehalf: 'Navrhol {app} v mene používateľa {name}',
  authorSuggestedByAppOnBehalf: 'Navrhla pripojená aplikácia v mene používateľa {name}',
  authorSuggestedAndApproved: 'Navrhol(-a) a schválil(-a) {name}',
  approverApprovedBy: 'schválil(-a) {name}',
  approverAppliedBy: 'použil(-a) {name}',
  kindCreatePage: 'Nová stránka',
  kindUpdatePage: 'Navrhovaná aktualizácia',
  kindArchivePage: 'Archivácia',
  statusConflict: 'Konflikt · stránka sa zmenila',
  statusPending: 'Čaká na kontrolu',
  statusApproved: 'Schválené',
  statusRejected: 'Odmietnuté',
  statusWithdrawn: 'Stiahnuté',
  statusSuperseded: 'Nahradené',
  errRevisionConflict: 'Táto stránka sa zmenila, kým ste ju kontrolovali.',
  errProposalChanged:
    'Tento návrh sa zmenil, kým ste ho kontrolovali. Pred rozhodnutím skontrolujte najnovšiu verziu.',
  errPublishRequired:
    'Zmeny znalostí môžu schvaľovať a stránky importovať iba publikujúci v spoločnosti.',
  errProposalLimit:
    'Vo vašej spoločnosti už na kontrolu čaká 200 návrhov. Pred ďalšími návrhmi niektoré skontrolujte.',
  errAuthorLimit:
    'Na kontrolu už čaká 50 vašich návrhov. Pred ďalšími návrhmi počkajte, kým sa o niektorých rozhodne, alebo niektoré stiahnite.',
  errImportProposalLimit:
    'Tento import by pridal na kontrolu viac zmenených stránok, než sa zmestí do frontu kontroly vašej spoločnosti (najviac 200). Rozhodnite o niektorých návrhoch v časti Na kontrolu a potom import použite znova.',
  errImportChanged:
    'Toto nie je import, ktorý ste kontrolovali. Pred použitím ho znova otvorte a skontrolujte.',
  errImportItemNotFound: 'Tento dokument už nie je súčasťou importu.',
  errIdempotencyConflict:
    'Tento návrh už bol odoslaný s iným obsahom. Načítajte stránku znova a skúste to znova.',
  errImportHashMismatch:
    'Súbor v tejto snímke sa nezhoduje so zaznamenaným kontrolným súčtom. Vytvorte novú snímku a skúste to znova.',
  errImportAlreadyApplied: 'Tento import už bol použitý.',
  errImportDiscarded: 'Tento import bol zahodený. Vyberte súbor snímky znova.',
  errImportDuplicateItem: 'Táto snímka obsahuje ten istý dokument dvakrát. Vytvorte snímku znova.',
  errInvalidImport:
    'Poneva nemohla túto snímku prijať. Vytvorte novú skriptom na snímky a skúste to znova.',
  errInvalidInput: 'Poneva nemohla prijať tento vstup. Skontrolujte polia a skúste to znova.',
  errImportLimit:
    'Príliš veľa importov je pripravených, ale nepoužitých. Pred prípravou ďalšieho niektoré použite alebo zahoďte.',
  errPageTooLarge: 'Stránka je väčšia ako 256 KB. Rozdeľte ju na menšie stránky.',
  errTooManySections: 'Stránka má viac ako 2 000 nadpisov. Rozdeľte ju na menšie stránky.',
  errPageLimit: 'Vaša spoločnosť dosiahla limit 2 000 stránok znalostí.',
  errCollectionLimit: 'Vaša spoločnosť dosiahla limit 100 tém.',
  errProposalNotPending: 'O tomto návrhu už bolo rozhodnuté. Zobrazený stav je aktuálny.',
  errRequesterRemoved:
    'Osoba, ktorá to navrhla, už nie je v tejto spoločnosti, preto sa návrh nedá schváliť.',
  errRevisionAlreadyCurrent: 'Táto revízia už je aktuálna.',
  errPageArchived:
    'Táto stránka bola archivovaná, kým ste ju kontrolovali. Pred rozhodnutím návrh skontrolujte znova.',
  errAlreadyArchived: 'Táto stránka už je archivovaná.',
  errProposalForbidden: 'Stiahnuť ho môže iba osoba, ktorá tento návrh podala.',
  errUnavailable: 'Stránky znalostí sú momentálne nedostupné.',
  errTimeout: 'Poneva odpovedala príliš dlho.',
  errItemTooLarge: '{path} je väčší ako 256 KB. Rozdeľte ho na menšie stránky.',
  errItemTooManySections: '{path} má viac ako 2 000 nadpisov. Rozdeľte ho na menšie stránky.',
  errItemHashMismatch:
    '{path} sa nezhoduje so zaznamenaným kontrolným súčtom. Vytvorte novú snímku a skúste to znova.',
  errNoLongerAvailable: 'Táto položka už pre vás nie je k dispozícii.',
  errTooLargeToSend: 'Tento súbor je príliš veľký na odoslanie.',
  cardChecking: 'Kontroluje sa stav…',
  cardNotAvailable: 'Nie je k dispozícii',
  cardStatusUnavailable: 'Stav nie je k dispozícii',
  cardUnshowable: 'Túto navrhovanú aktualizáciu znalostí sa nepodarilo zobraziť.',
  cardEyebrow: 'Navrhovaná aktualizácia znalostí',
  cardLabel: 'Navrhovaná aktualizácia znalostí · {title}',
  cardMissing: 'Tento návrh už pre vás nie je k dispozícii.',
  cardUnknown:
    'Nepodarilo sa overiť, v akom stave je tento návrh. Stav zistíte po otvorení kontroly.',
  cardCheckAgain: 'Skontrolovať znova',
  cardReview: 'Skontrolovať aktualizáciu',
  statusLineApproved: 'Schválené poznatky',
  readyCount:
    'one:pripravený na vyhľadávanie|few:pripravené na vyhľadávanie|many:pripraveného na vyhľadávanie|other:pripravených na vyhľadávanie',
  preparingCount: 'one:v príprave|few:v príprave|many:v príprave|other:v príprave',
  attentionCount:
    'one:vyžaduje pozornosť|few:vyžadujú pozornosť|many:vyžaduje pozornosť|other:vyžaduje pozornosť',
  topicsExplore: 'Preskúmať tému',
  topicsAllPages: 'Všetky stránky',
  topicsOpenPages: 'Otvoriť Stránky',
  topicsEmpty:
    'Zatiaľ žiadne schválené stránky. Stránky obsahujú podrobné poznatky o spoločnosti s úplnou históriou revízií.',
  reviewsTitle: 'Navrhované aktualizácie stránok',
  reviewsTitleMine: 'Vaše navrhované aktualizácie stránok',
  reviewsIntro:
    'Každý návrh je úplná kandidátska revízia s odôvodnením a dôkazmi. Nič sa nezmení, kým neschválite presne túto revíziu.',
  reviewsIntroMine:
    'Vaše návrhy tu čakajú, kým ich neskontroluje publikujúci v spoločnosti. Dovtedy zostanú stránky bez zmeny.',
  loadPagesFailed: 'Stránky znalostí sa nepodarilo načítať.',
  loadProposalsFailed: 'Navrhované aktualizácie stránok sa nepodarilo načítať.',
  loadMoreFailed: 'Ďalšie stránky sa nepodarilo načítať.',
  otherPages: 'Ďalšie stránky',
  loadTopicFailed: 'Túto tému sa nepodarilo načítať.',
  revisionShort: 'r{n}',
  updatedOn: 'Aktualizované {date}',
  emptyTitle: 'Zatiaľ žiadne stránky znalostí.',
  emptyBody:
    'Stránky obsahujú schválené podrobné poznatky vašej spoločnosti — smerovanie, rozhodnutia a spôsoby práce — a uchovávajú každú revíziu. Importujte ich zo snímky repozitára alebo začnite stránku v chate; každú stránku musí schváliť publikujúci, kým sa začne považovať za znalosti spoločnosti.',
  importFromSnapshot: 'Importovať zo snímky repozitára',
  startInChat: 'Začať stránku v chate',
  startInChatPrompt:
    'Pomôž mi založiť stránku znalostí pre našu spoločnosť. Opýtaj sa, čo má pokrývať, a nevymýšľaj obsah. Kým ju neschváli publikujúci v spoločnosti, zostane návrhom.',
  loadingPages: 'Načítavajú sa stránky znalostí…',
  filterLabel: 'Filtrovať stránky podľa názvu',
  filterPlaceholder: 'Filtrovať stránky',
  importButton: 'Importovať',
  showingTopic: 'Zobrazuje sa téma {topic}',
  showAllTopics: 'Zobraziť všetky témy',
  loadingTopic: 'Načítava sa táto téma…',
  noMatch: 'Výrazu „{filter}“ nezodpovedajú žiadne stránky.',
  topicNoPages: 'V tejto téme zatiaľ nie sú žiadne schválené stránky.',
  loading: 'Načítava sa…',
  loadMore: 'Načítať ďalšie stránky',
  metaApproved: 'schválené {date}',
  metaRepositoryAuthoritative: 'rozhodujúci zostáva repozitár',
  loadPageFailed: 'Túto stránku sa nepodarilo načítať.',
  loadHistoryFailed: 'Históriu revízií sa nepodarilo načítať.',
  outlineLabel: 'Sekcie stránky',
  outlineToggle: 'Na tejto stránke',
  loadingHistory: 'Načítava sa história revízií…',
  historyLabel: 'História revízií',
  historyIntro:
    'Každá schválená revízia sa uchováva. Obnovenie staršej revízie vytvorí návrh na kontrolu; neskoršie revízie nikdy nevymaže.',
  historyCurrent: 'Aktuálna',
  historyViewing: 'Zobrazená',
  historyView: 'Zobraziť',
  historyViewAria: 'Zobraziť revíziu {n}',
  restoreAria: 'Obnoviť ako návrh: revízia {n}',
  restoreCreating: 'Vytvára sa návrh…',
  restore: 'Obnoviť ako návrh',
  restoreUnconfirmed:
    'Nepodarilo sa overiť, či bol návrh vytvorený. Skôr než to skúsite znova, pozrite sa do časti Na kontrolu.',
  editTooLarge: 'Táto stránka je väčšia ako 256 KB. Pred navrhnutím ju rozdeľte na menšie stránky.',
  editConflict:
    'Táto stránka sa zmenila, kým ste ju upravovali. Skopírujte svoj text, otvorte najnovšiu revíziu a navrhnite úpravu znova.',
  editUnconfirmed:
    'Nepodarilo sa overiť, či bol váš návrh odoslaný. Skôr než ho odošlete znova, pozrite sa do časti Na kontrolu.',
  editHeading: 'Navrhnúť úpravu',
  editIntro:
    'Upravujete revíziu {n}. Publikujúci v spoločnosti skontroluje presnú zmenu, kým sa z nej stane revízia {next}; dovtedy zostane stránka bez zmeny.',
  editOutdated:
    'Kým ste upravovali, bola schválená novšia revízia. Skopírujte svoj text a začnite znova od najnovšej revízie, aby sa nestratilo nič, čo v nej bolo zmenené.',
  editContentLabel: 'Obsah stránky (Markdown)',
  editReasonLabel: 'Prečo táto zmena?',
  editReasonPlaceholder: 'Čo sa zmenilo a odkiaľ to pochádza.',
  editSending: 'Odosiela sa…',
  editSend: 'Odoslať na kontrolu',
  editDiscardConfirm: 'Zahodiť túto úpravu? Nič z toho, čo ste zmenili, nebolo odoslané.',
  editNoChanges: 'Zatiaľ žiadne zmeny.',
  editNeedsContent: 'Stránka musí mať nejaký obsah.',
  exportFailed: 'Túto stránku sa nepodarilo exportovať. Skúste to znova.',
  askPagePrompt: 'Otázka k stránke znalostí „{title}“ (revízia {n}, {link}):',
  askPageSectionPrompt: 'Otázka k stránke znalostí „{title}“ § {section} (revízia {n}, {link}):',
  pageMissingTitle: 'Táto stránka nie je k dispozícii.',
  pageMissingBody: 'Možno bola archivovaná alebo už nemáte prístup k znalostiam tejto spoločnosti.',
  pageArchived: 'Archivovaná',
  viewingRevisionCurrent: 'Zobrazujete revíziu {n}; aktuálna revízia je {current}.',
  viewingRevisionOld: 'Zobrazujete revíziu {n}. Nie je to aktuálna revízia.',
  openCurrent: 'Otvoriť aktuálnu',
  archivedBanner:
    'Táto stránka je archivovaná. Už neslúži ako podklad pre odpovede; jej história sa uchováva.',
  pageViewsLabel: 'Zobrazenia stránky',
  tabRead: 'Čítať',
  tabHistory: 'História',
  unknownSection: 'Prepojená sekcia nie je súčasťou tejto revízie. Zobrazuje sa celá stránka.',
  askAboutPage: 'Opýtať sa na túto stránku',
  exporting: 'Exportuje sa…',
  exportMarkdown: 'Exportovať do Markdownu',
  loadSuggestionFailed: 'Tento návrh sa nepodarilo načítať.',
  evidenceSource: 'Zdroj',
  evidenceFact: 'Kontext spoločnosti',
  evidenceResult: 'Uložená práca',
  evidenceUrl: 'Webová stránka',
  evidenceDecision: 'Rozhodnutie',
  evidenceReference: 'Odkaz',
  evidenceOpenPage: 'Otvoriť stránku znalostí',
  evidenceOpenSource: 'Otvoriť zdroj',
  evidenceOpenFact: 'Otvoriť kontext spoločnosti',
  evidenceOpenResult: 'Otvoriť uloženú prácu',
  evidenceOpenUrl: 'Otvoriť webovú stránku',
  evidenceOpenDecision: 'Otvoriť rozhodnutie',
  evidenceOpenReference: 'Otvoriť odkaz',
  evidenceDecisionNote: 'Zaznamenané rozhodnutie. V Poneva nie je čo otvoriť.',
  evidenceFactGone: 'Tento kontext spoločnosti už nie je uložený.',
  evidencePageNoRevision:
    'Táto stránka nemá žiadnu schválenú revíziu, ktorú by bolo možné otvoriť.',
  evidencePrivateExcerpt: 'Súkromný dôkaz — zdieľaný bol iba úryvok vyššie.',
  evidencePrivate: 'Súkromný dôkaz — jeho obsah s vami nebol zdieľaný.',
  evidenceHeading: 'Dôkazy',
  evidenceNone: 'Neboli priložené žiadne dôkazy. Posúďte samotné odôvodnenie vyššie.',
  changeAdded: 'Pridané',
  changeRemoved: 'Odstránené',
  changeChanged: 'Zmenené',
  changeUnchanged: 'Bez zmeny',
  moreLineCount: 'one:ďalší riadok|few:ďalšie riadky|many:ďalšieho riadka|other:ďalších riadkov',
  moreUnchangedLineCount:
    'one:ďalší nezmenený riadok|few:ďalšie nezmenené riadky|many:ďalšieho nezmeneného riadka|other:ďalších nezmenených riadkov',
  unchangedLineCount:
    'one:nezmenený riadok|few:nezmenené riadky|many:nezmeneného riadka|other:nezmenených riadkov',
  skipAdded: '{lines} — nájdete v úplnej revízii',
  skipRemoved: 'Odstránené: {lines}',
  cutUnchanged: 'Nezobrazené: {lines}',
  cutChanged: 'Nezobrazené: {lines} ({changes}). Skontrolujte ich v úplnej revízii.',
  cutAddedRemoved: 'pridané: {added}, odstránené: {removed}',
  cutAdded: 'pridané: {added}',
  cutRemoved: 'odstránené: {removed}',
  lineAddedSr: 'Pridané:',
  lineRemovedSr: 'Odstránené:',
  noLinesAdded: 'Nová sekcia. Jej text nájdete v úplnej revízii nižšie.',
  noLinesRemoved: 'Táto sekcia by sa zo stránky odstránila.',
  noLinesChanged: 'Táto sekcia sa mení. Jej text nájdete v úplnej revízii nižšie.',
  diffHeading: 'Zmeny',
  outcomeArchived: 'Archivované.',
  outcomeArchivedBody:
    '{title} už neslúži ako podklad pre odpovede a zmizla zo zoznamu stránok. Jej revízie, tento návrh a rozhodnutie zostávajú v histórii stránky.',
  openArchivedPage: 'Otvoriť archivovanú stránku',
  outcomeApproved: 'Schválené.',
  outcomeApprovedRevision: 'Revízia {n} je teraz schválenou verziou stránky {title}.',
  outcomeApprovedPlain: 'Tento návrh bol schválený.',
  outcomeRestored: 'Stránka je späť v zozname stránok a opäť slúži ako podklad pre odpovede.',
  outcomeKept: 'Návrh, rozhodnutie a všetky predchádzajúce revízie zostávajú v histórii stránky.',
  openPage: 'Otvoriť stránku',
  outcomeDismissed: 'Odmietnuté.',
  outcomeWithdrawn: 'Stiahnuté.',
  outcomeSuperseded: 'Nahradené.',
  outcomeSupersededBody:
    'Novšia revízia, návrh alebo import z repozitára spravili tento návrh zastaraným. Sám o sebe nič nezmenil.',
  outcomeUnchanged: 'Stránka zostáva bez zmeny.',
  approveNewPage: 'Schváliť novú stránku',
  approveArchive: 'Schváliť archiváciu',
  approveRestoreRevision: 'Obnoviť a schváliť revíziu {n}',
  approveRevision: 'Schváliť revíziu {n}',
  approveArchiveNote: 'Schválením sa táto stránka archivuje pre všetkých v rámci {company}.',
  approvePublishNote: 'Schválením sa táto revízia zverejní pre všetkých v rámci {company}.',
  approvePublishEvidenceNote:
    'Schválením sa táto revízia a úryvky dôkazov zobrazené vyššie zverejnia pre všetkých v rámci {company}.',
  archivedTitle: 'Táto stránka je archivovaná.',
  alreadyArchivedBody: 'Schválenie by nič nezmenilo, preto možno tento návrh iba odmietnuť.',
  archivedRestoreBody:
    'Schválením sa stránka obnoví: s touto revíziou sa vráti do zoznamu stránok, vyhľadávania aj odpovedí.',
  staleRevisionAction: 'Porovnať s najnovšou verziou',
  staleProposalTitle: 'Tento návrh sa zmenil, kým ste ho kontrolovali.',
  staleProposalAction: 'Skontrolovať najnovšiu verziu',
  staleArchivedTitle:
    'Táto stránka bola archivovaná, kým ste ju kontrolovali. Schválením tohto návrhu by sa vrátila späť.',
  staleArchivedAction: 'Skontrolovať znova',
  suggestionMissingTitle: 'Tento návrh nie je k dispozícii.',
  suggestionMissingBody:
    'Možno bol stiahnutý alebo patrí niekomu inému a nebol odoslaný na kontrolu v spoločnosti.',
  decideUnconfirmed:
    'Vaše rozhodnutie sa nepodarilo overiť. Zobrazený stav je najnovší z Poneva; pred ďalším pokusom ho skontrolujte.',
  decideFailed: 'Vaše rozhodnutie sa nepodarilo uložiť.',
  discussPrompt:
    'Pomôž mi vylepšiť navrhovanú aktualizáciu znalostí pre stránku „{title}“ ({link}).',
  conflictBody:
    'Tento návrh bol napísaný k revízii {base}; aktuálna revízia je {current}. Jeho schválením by sa táto zmena prepísala, preto ho v tejto podobe nemožno schváliť.',
  conflictBodyPlain:
    'Tento návrh bol napísaný k staršej revízii, preto ho v tejto podobe nemožno schváliť.',
  openLatest: 'Otvoriť najnovšiu verziu',
  reworkInChat: 'Prepracovať v chate',
  factReason: 'Odôvodnenie',
  factNoReason: 'Nebolo uvedené žiadne odôvodnenie.',
  factAudience: 'Publikum',
  factRevision: 'Revízia',
  revisionNew: 'Nová stránka, revízia 1',
  revisionArchiveAfter: 'Archivovať po revízii {n}',
  revisionWrittenAgainst: 'Napísané k revízii {base}; aktuálna revízia je {current}',
  revisionCurrentToProposed: 'Aktuálna revízia {base} → navrhovaná revízia {next}',
  revisionProposed: 'Navrhovaná revízia {next}',
  proposedPage: 'Navrhovaná stránka',
  archivingHeading: 'Čo archivácia robí',
  archivingBody:
    'Stránka prestane slúžiť ako podklad pre odpovede a zmizne zo zoznamu stránok. Jej revízie a toto rozhodnutie sa uchovajú.',
  noComparison: 'Porovnanie sekcií nie je pre tento návrh k dispozícii.',
  showComplete: 'Zobraziť úplnú revíziu',
  approving: 'Schvaľuje sa…',
  dismissing: 'Odmieta sa…',
  dismiss: 'Odmietnuť',
  withdrawing: 'Sťahuje sa…',
  withdraw: 'Stiahnuť',
  editInChat: 'Upraviť v chate',
  waitingForPublisher: 'Čaká sa, kým to skontroluje publikujúci v spoločnosti.',
  snapshotTooLarge: 'Táto snímka je väčšia ako 8 MB. Vytvorte ju s menším počtom dokumentov.',
  snapshotNotSnapshot:
    'Tento súbor nie je snímka znalostí. Vyberte súbor JSON, ktorý vytvoril skript na snímky.',
  snapshotEmpty: 'Táto snímka neobsahuje žiadne dokumenty.',
  readDocumentFailed: 'Tento dokument sa nepodarilo prečítať. Skúste to znova.',
  readingDocument: 'Číta sa dokument…',
  hideText: 'Skryť text',
  readText: 'Čítať text',
  textOf: 'Text dokumentu {title}',
  gitSnapshot: 'Snímka Git {commit}',
  repositorySnapshot: 'Snímka repozitára',
  importNewHeading: '{pages} · schvália sa pri použití importu',
  importNewNote:
    'Každá sa zverejní ako schválená stránka pre všetkých v spoločnosti {company}, bez ďalšej kontroly. Pred použitím si každú prečítajte.',
  importChangedHeading: '{pages} · odošlú sa na kontrolu',
  importChangedNote:
    'Z každej sa stane navrhovaná aktualizácia. Jej stránka sa zmení až vtedy, keď ju publikujúci schváli v časti Na kontrolu, kde uvidí, čo sa zmenilo.',
  unchangedDocumentCount:
    'one:nezmenený dokument|few:nezmenené dokumenty|many:nezmeneného dokumentu|other:nezmenených dokumentov',
  unchangedNote:
    'Tieto dokumenty sa už zhodujú so svojimi schválenými stránkami. Nič sa pre ne nezapíše.',
  stagedHeading: 'Pripravené, ale nepoužité',
  excludedSummary: 'Vynechané z tejto snímky: {documents}',
  countsLine: '{newPages} · na kontrolu: {changedPages} · bez zmeny: {unchanged}',
  importAlreadyDiscarded: 'Tento import už bol zahodený.',
  confirmLabel: 'Potvrdiť import',
  unchangedKeepCount:
    'one:nezmenený dokument si ponechá svoju stránku|few:nezmenené dokumenty si ponechajú svoje stránky|many:nezmeneného dokumentu si ponechá svoje stránky|other:nezmenených dokumentov si ponechá svoje stránky',
  confirmBody:
    'Použiť tento import pre všetkých v spoločnosti {company}? Schválené ako revízia 1: {newPages}. Čakajúce na kontrolu: {changedPages}. {unchanged}. Predchádzajúce návrhy z importu pre tieto stránky sa stiahnu.',
  applying: 'Používa sa…',
  applyImport: 'Použiť import',
  chooseAnother: 'Vybrať iný súbor',
  allCurrent: 'Všetko v tejto snímke je už aktuálne.',
  importApplied: 'Import bol použitý.',
  appliedSummary: 'Vytvorené: {pages} · čaká na kontrolu: {changes} · bez zmeny: {unchanged}.',
  appliedIndexing:
    'Nové stránky bude možné vyhľadávať v chate po dokončení indexovania. Priebeh zobrazuje príprava zdrojov.',
  openPages: 'Otvoriť stránky',
  reviewChanges: 'Skontrolovať: {changes}',
  checkIndexing: 'Skontrolovať priebeh indexovania',
  sendSnapshotFailed: 'Túto snímku sa nepodarilo odoslať. Skúste to znova.',
  openStagedFailed: 'Tento pripravený import sa nepodarilo otvoriť.',
  applyUnconfirmed:
    'Nepodarilo sa overiť, či bol import použitý. Skôr než to skúsite znova, pozrite sa do časti Stránky.',
  applyFailed: 'Tento import sa nepodarilo použiť.',
  importHeading: 'Importovať stránky z repozitára',
  backToPages: 'Späť na stránky',
  importLead:
    'Vytvorte snímku príkazom {command} a potom vyberte súbor. Skôr než sa čokoľvek uloží, uvidíte každý dokument a to, čo by zmenil.',
  snapshotFileLabel: 'Súbor snímky znalostí',
  readingSnapshot: 'Číta sa snímka…',
  openingStaged: 'Otvára sa pripravený import…',
  chooseSnapshot: 'Vybrať súbor snímky',
  factOrigin: 'Pôvod',
  factContents: 'Obsah',
  importOnlyListed: 'Importujú sa iba dokumenty uvedené tu.',
  importRepositoryAuthoritative:
    'Rozhodujúci zostáva repozitár; zmenené dokumenty sa stanú návrhmi na kontrolu.',
  overviewReviewChanges: 'Skontrolovať zmeny',
  overviewConnectAgents: 'Pripojiť externých agentov',
  overviewEyebrow: 'Spoločné porozumenie',
  overviewTitle: '{company} v kontexte.',
  overviewLeadFallback:
    'Znalosti vašej spoločnosti začínajú kontextom, ktorý zdieľate. Budujte spoločne porozumenie svojmu podnikaniu.',
  overviewBody:
    'Kontext spoločnosti a zdrojové materiály sú pre Poneva východiskom — nie všetkým, čo sa dá o spoločnosti {company} vedieť. Rozvíjajte toto porozumenie spolu s tým, ako sa vaše podnikanie vyvíja.',
  overviewAskPrompt: 'Čo vieš o našej spoločnosti a čo by bolo užitočné doplniť?',
  overviewAsk: 'Opýtať sa na {company}',
  overviewAddSources: 'Pridať zdroje',
  contextEyebrow: 'Čo dáva odpovediam kontext',
  contextTitle: 'Podnikanie za otázkou.',
  contextBody:
    'Webové zdroje vysvetľujú verejnú stránku podnikania. Poznámky o spoločnosti dopĺňajú vašu terminológiu, priority a spôsob práce.',
  contextPrompt:
    'Pomôž mi ujasniť priority spoločnosti a pracovné preferencie, ktoré by sme si mali zapamätať.',
  contextAction: 'Budovať naše porozumenie',
  learnEyebrow: 'Priestor na učenie',
  learnTitle: 'Začnite tým, na čom záleží ďalej.',
  learnBody:
    'Pridajte zdrojové materiály alebo ujasnite, ako vaša spoločnosť funguje. Poneva môže navrhnúť trvalé zmeny, ktoré skontrolujete.',
  learnPrompt:
    'Aké dôležité informácie chýbajú v našich existujúcich znalostiach spoločnosti pre prácu, ktorú chceme robiť?',
  learnAction: 'Prediskutovať, čo by bolo užitočné',
  canvasEmptyTitle: 'Aj trocha kontextu veľa zmení.',
  canvasEmptyBody:
    'Východiskom je profil vašej spoločnosti. Pridajte zdrojové materiály a skontrolované poznámky, aby Poneva lepšie rozumela vašej práci.',
  pageEyebrow: 'Pracovný priestor {company}',
  pageTitle: 'Znalosti spoločnosti',
  pageDescription: 'Zdroje a poznatky, z ktorých Poneva pri práci vychádza.',
  tabOverview: 'Prehľad',
  tabPages: 'Stránky',
  tabSources: 'Zdroje',
  tabReview: 'Na kontrolu',
  proposalApproved: 'Schválený kontext spoločnosti',
  proposalDismissed: 'Odmietnutý návrh',
  proposalRemoval: 'Navrhované odstránenie',
  proposalCorrection: 'Navrhovaná oprava',
  proposalContext: 'Navrhovaný kontext spoločnosti',
  proposalCurrent: 'Aktuálne poznatky',
  proposalFactGone:
    'Uložený fakt už nie je k dispozícii. Pred kontrolou tohto odstránenia obnovte znalosti spoločnosti.',
  proposalReviewFallback: 'Skontrolujte navrhovaný kontext spoločnosti.',
  proposalNotSaved: 'Zatiaľ neuložené. Pôvodné zdroje zostávajú bez zmeny.',
  proposalWaiting: 'Čaká na kontrolu · rozhodne publikujúci v Doručenej pošte',
  proposalSaving: 'Ukladá sa…',
  proposalApproveRemoval: 'Schváliť odstránenie',
  proposalApproveClarification: 'Schváliť spresnenie',
  factLabel: 'Fakt o spoločnosti',
  factEyebrow: 'Fakt · Všetci v spoločnosti {company}',
  factSuggestCorrection: 'Navrhnúť opravu',
  factAskPrompt: 'Pomôž mi pochopiť alebo spresniť tento uložený kontext spoločnosti: „{content}“',
  factAsk: 'Opýtať sa na to',
  companyContextHeading: 'Kontext spoločnosti',
  companyContextPrompt:
    'Chcem spresniť znalosti našej spoločnosti. Pomôž mi skontrolovať, čo vieme, a navrhnúť aktualizáciu.',
  companyContextEmpty:
    'Zatiaľ žiadne schválené poznámky. Začnite konverzáciu o svojej spoločnosti alebo nižšie pridajte zdrojové materiály.',
  refineInChat: 'Vylepšiť v chate',
  reviewPanelLabel: 'Zmeny znalostí na kontrolu',
  suggestedUpdatesHeading: 'Navrhované aktualizácie',
  suggestedUpdatesIntro:
    'Návrhy z vašich konverzácií. Vy rozhodujete, čo sa stane trvalou súčasťou znalostí vašej spoločnosti.',
  reviewEmptyTitle: 'Nič nečaká na vašu kontrolu.',
  reviewEmptyBody:
    'Keď Poneva navrhne zmenu znalostí vašej spoločnosti, nájdete ju tu. Trvalé zmeny vždy vyžadujú vaše schválenie.',
  reviewEmptyPrompt:
    'Pomôž mi skontrolovať znalosti našej spoločnosti a navrhni, čo by bolo užitočné spresniť ďalej.',
  inclusionPendingApproval: 'Zmena zahrnutia do znalostí bola odoslaná na schválenie.',
  sourcesFileIncluded:
    'Súbor bol zahrnutý do vyhľadávania v znalostiach pre svoje aktuálne publikum.',
  sourcesAddFailed: 'Tento zdroj sa nepodarilo pridať.',
  sourcesHeading: 'Materiály, z ktorých vychádzajú odpovede.',
  sourcesIntro:
    'Poneva prehľadáva celé zdrojové materiály, nielen prehľad. Uchovajte originály, pozrite si, čo je pripravené, a vyberte, z čoho majú vaše odpovede vychádzať.',
  addSourceHeading: 'Pridajte materiály zo svojej spoločnosti',
  addSourceIntro:
    'Nahrané zdroje zostávajú súkromné vo vašej Knižnici a slúžia len pre vaše vlastné odpovede. Keď ich budete chcieť sprístupniť kolegom, vyberte Zdieľať.',
  uploadSource: 'Nahrať zdroj',
  addSourcePrompt:
    'Pomôž mi pridať vyhlásenie spoločnosti ako zdieľaný interný zdroj. Opýtaj sa, čo chcem zaznamenať; nevymýšľaj žiadny obsah. Trvalé zmeny v poznatkoch o spoločnosti stále vyžadujú moje schválenie.',
  addThroughChat: 'Pridať cez chat',
  addingSource: 'Pridáva sa…',
  addToKnowledge: 'Pridať do znalostí',
  uploadFormats: 'TXT, Markdown, CSV a JSON · Najviac 5 MB na súbor',
  sourceExcluded: 'Vylúčené z odpovedí',
  sourcePreparationFailed: 'Príprava zlyhala',
  sourcePreparing: 'Pripravuje sa na vyhľadávanie',
  sourceWaiting: 'Čaká na prípravu',
  sourceReadinessUnknown: 'Stav pripravenosti nie je k dispozícii',
  sourceRetryQueued:
    'Príprava bola zaradená do frontu. Stav pripravenosti sa aktualizuje po jej dokončení.',
  sourceIncludedNotice: 'Zdroj bol zahrnutý. Poneva ho pripraví na vyhľadávanie.',
  sourceExcludedNotice: 'Vylúčené z odpovedí. Pôvodný zdroj sa uchováva.',
  sourceUpdateFailed: 'Tento zdroj sa nepodarilo aktualizovať.',
  sourceOriginalMaterial: 'Pôvodný zdrojový materiál',
  sourceDiscuss: 'Prediskutovať v chate',
  sourceDiscussPrompt: 'Pomôž mi pochopiť alebo spresniť „{title}“.',
  sourceExclude: 'Vylúčiť z odpovedí',
  sourceInclude: 'Zahrnúť do odpovedí',
  sourcesLoadFailed: 'Vaše zdroje sa nepodarilo načítať.',
  sourceLibraryLabel: 'Knižnica zdrojov spoločnosti',
  sourceListCaption: 'Pôvodné zdroje · zahrnuté aj vylúčené',
  sourceSearchLabel: 'Hľadať v zdrojoch spoločnosti',
  sourceSearchPlaceholder: 'Hľadať vo svojich zdrojoch…',
  sourcesFinding: 'Hľadajú sa vaše zdroje…',
  sourcePagesLabel: 'Stránky zdrojov',
  sourceRange: '{from}–{to} z {count}',
  sourceCount: 'one:zdroj|few:zdroje|many:zdroja|other:zdrojov',
  sourcePrevious: 'Predchádzajúca',
  sourceNext: 'Ďalšia',
  sourceNoMatchTitle: 'Žiadne zodpovedajúce zdroje.',
  sourceNoMatchBody: 'Skúste iný výraz alebo názov zdroja.',
  sourceEmptyTitle: 'Dajte svojim otázkam lepší východiskový bod.',
  sourceEmptyBody:
    'Pridajte dokumenty spoločnosti, produktové údaje alebo pracovné poznámky. Poneva môže celé zdrojové materiály využívať v konverzáciách aj v Skills.',
  indexCheckFailed: 'Nepodarilo sa skontrolovať prípravu zdrojov.',
  indexRetryQueued:
    'Neúspešné položky znalostí boli zaradené do frontu na prípravu. Vaše zdrojové materiály sa nezmenili.',
  indexQueueFailed: 'Prípravu sa nepodarilo zaradiť do frontu. Skúste to znova.',
  indexPreparing: 'Pripravujú sa nové znalosti pre vaše konverzácie…',
  indexAttention: 'Niektoré znalosti vyžadujú pozornosť.',
  queuing: 'Zaraďuje sa do frontu…',
  retryPreparation: 'Zopakovať prípravu',
  sourceKindStatement: 'Vyhlásenie spoločnosti',
  sourceKindWebsite: 'Webová stránka',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:odpoveď|few:odpovede|many:odpovede|other:odpovedí',
  factUsedThisWeek: 'Použité tento týždeň: {answers}',
  factLastUsed: 'naposledy použité: {when}',
  factToday: 'dnes',
  factYesterday: 'včera',
  factImpact: 'Táto zmena ovplyvní fakt použitý tento týždeň ({answers}).',
  factCorrectionAbout: 'K tomuto faktu o spoločnosti: „{content}“ ({link})',
  factCorrectionOutdated: 'Toto už neplatí:',
  sourceCanvasRecorded: 'Zaznamenaný zdrojový materiál',
  sourceCanvasNotIncluded:
    'Nie je súčasťou znalostí spoločnosti. Originál sa uchováva na referenciu a stále ho možno použiť v konkrétnej konverzácii.',
  sourceCanvasOpenOriginal: 'Otvoriť pôvodný zdroj',
  sourceCanvasUnavailable: 'Obsah zdroja nie je k dispozícii.',
  sourceCanvasDiscussPrompt: 'Pomôž mi pochopiť alebo ujasniť „{title}“.',
  sourceCanvasDiscuss: 'Prebrať tento zdroj',
  sourceCanvasCorrectionNote:
    'Oprava sa stane navrhovaným kontextom spoločnosti. Zaznamenaný zdroj zostane nezmenený.',
  contextCanvasEyebrow: 'Dostupný kontext spoločnosti',
  contextCanvasTitle: 'Znalosti za touto konverzáciou.',
  contextCanvasBody:
    'Schválené poznatky a zdrojové materiály, ktoré pridala vaša spoločnosť. K dispozícii v chate a v Skills.',
  contextCanvasOpen: 'Otvoriť Znalosti',
};

export default sk;
